"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { TheContent, headerDated } from "@/helpers/utils";

export default function NoticiaSingular({ data }) {
  if (!data) return null;
  return (
    <div className="max-w-[880px] m-auto flex flex-col items-center bg-white">

      {/* Banner da notícia */}
      <section className="w-full  px-4">
        <div className="max-w-[1440px] pt-34  w-full mx-auto flex justify-center">
          {data.contentImages1?.mediaCdnUrl && (
            <Image
              src={ data.contentImages1.mediaCdnUrl }
              alt="Notícia"
              width={1440}
              height={400}
              className="object-cover rounded-2xl"
            />
          )}
        </div>
      </section>

      {/* Conteúdo da notícia */}
      <section className="w-full py-12 px-4">
        <div className="max-w-[1440px] mx-auto flex flex-col items-start">
          <h1 className="text-blue-700 text-[40px] font-bold mb-2">
            { data.contentTitle}
          </h1>
          <p className="text-blue-700 text-[12px] font-light mb-6">
            Publicado em { headerDated(data.createdAt) }
          </p>

          <div className="text-blue-700 text-[18px] leading-relaxed space-y-6 mb-8">
            { TheContent(data.contentEditor1) }
          </div>

          {/* Botão voltar */}
          <Link
            href="/noticias"
            className="px-6 py-3 bg-blue-700 text-white rounded-lg hover:bg-blue-800 transition"
          >
            ← Voltar para Notícias
          </Link>
        </div>
        <div className="w-full max-w-[1440px] mx-auto flex flex-col items-center text-center">
          <img
            src="/assets/logos1.png"
            alt="Logos"
            className="w-[200px] sm:w-[350px] md:w-[400px] mb-10"
          />
        </div>
      </section>

    </div>
  );
}
